﻿import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import StepProgressBar from '../../../UI/StepProgressBar';
import RawHtml from '../../../UI/RawHtml';

import definitions from '../../../Style/LfStyleDefinitions';
import { iconCode, mediaQuery, clearFix } from '../../../Style/cssHelpers';

const stepLabels = [
    'Svara på frågor',
    'Bekräfta svar',
    'Bekräftelse'
];

const HealthDeclarationHeader = ({appliesToCoinsured, headerData, step}) => {
    return (
        <div>
            <Heading>
                {headerData.headings[step]}
            </Heading>
            <Preamble>
                <RawHtml>
                    {headerData.preambles[step]}
                </RawHtml>
                {appliesToCoinsured &&
                    <Notice>
                        Observera att det är den medförsäkrades personuppgifter och hälsotillstånd som skall anges.
                    </Notice>
                }
            </Preamble>
            <StepProgressBar
                stepLabels={stepLabels}
                stepCount={stepLabels.length}
                activeStep={step}
                hideDescOnResp={true}
            />
        </div>
    );
}

export default HealthDeclarationHeader;

// styles

const Heading = styled.h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${definitions.fonts.heading};
    font-size: 60px;
    color: ${definitions.colors.almostBlack};

    border-bottom: 1px solid ${definitions.colors.grayBorder};

     ${mediaQuery.custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${mediaQuery.small(`
        border: none;
        font-size: 28px;
        padding-bottom: 0px;
        margin-bottom: 10px;
        margin-top: 31px;
    `)}

     ${mediaQuery.xxsmall(`
        font-size: 20px;
    `)}
`;

const Preamble = styled.div`
    max-width: 60%;
    width: auto;

    margin-bottom: 20px;

    font-family: ${definitions.fonts.main};
    font-size: 20px;
    color: ${definitions.colors.almostBlack};

    ${mediaQuery.custom(`
        margin-left: 17px;
        margin-right: 17px;
    `, '1234px')}

    ${mediaQuery.small(`
        margin-bottom: 15px;
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}

    ${mediaQuery.xxsmall(`
        font-size: 13px;
    `)}
`;

const Notice = styled.div`
    padding: 20px 0 0 0;
    ${mediaQuery.small(`
        padding: 15px 0 0 0;
    `)}

    font-family: ${definitions.fonts.heading};
    font-weight: bold;
    font-size: inherit;

    color: ${definitions.colors.error};
`;
